import React from "react";
import styles from "../../components/Report/CardBox.module.css";

export interface ImpactOfLivingQuestion {
  questionText: string;
  impact: string;
  impactAfterChange?: number;
  category?: string;
}

export interface ImpactOfLivingData {
  questionData: ImpactOfLivingQuestion[];
  averagePercentage: number;
}

interface Props {
  impactData?: ImpactOfLivingData | null;
  heading?: string;
  intakeFormDataloading?: boolean;
  showFunctionLevelTable?: boolean;
}

const NewCardBox: React.FC<Props> = ({
  impactData,
  heading = "FUNCTION LEVEL",
  intakeFormDataloading = false,
  showFunctionLevelTable = false,
}) => {
  if (intakeFormDataloading) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 style={{ fontWeight: "bold" }}>{heading}</h2>
        </div>
        <div className={styles.loading}>Loading impact data...</div>
      </div>
    );
  }

  if (!impactData || !impactData.questionData?.length) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 style={{ fontWeight: "bold" }}>{heading}</h2>
        </div>
        <div className={styles.noData}>No data available</div>
      </div>
    );
  }

  // Group questions by category if categories exist
  const hasCategories = impactData.questionData.some((q) => q.category);
  const groupedData = hasCategories
    ? impactData.questionData.reduce<Record<string, ImpactOfLivingQuestion[]>>(
        (acc, item) => {
          const category = item.category || "Other";
          if (!acc[category]) {
            acc[category] = [];
          }
          acc[category].push(item);
          return acc;
        },
        {}
      )
    : null;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 style={{ fontWeight: "bold" }}>{heading}</h2>
      </div>

      {showFunctionLevelTable && (
        <div className={styles.subHeading}>
          Higher number represent better functioning. Scale(0-10 )
        </div>
      )}

      {showFunctionLevelTable && (
        <div className={styles.tableContainer}>
          <table className={styles.functionTable}>
            <tbody>
              {groupedData
                ? Object.entries(groupedData).flatMap(([category, questions]) =>
                    questions.map((item, index) => (
                      <tr key={`${category}-${index}`}>
                        <td
                          className={`${styles.scoreCell} ${styles.withBorder}`}
                        >
                          {item.impact}
                        </td>
                        <td className={styles.categoryCell}>{category}</td>
                        {/* <td className={styles.descriptionCell}>
                          <div className={styles.questionText}>
                            {item.questionText}
                          </div>
                        </td> */}
                      </tr>
                    ))
                  )
                : impactData.questionData.map((item, index) => (
                    <tr key={index}>
                      <td
                        className={`${styles.scoreCell} ${styles.withBorder}`}
                      >
                        <strong>{item.impact}</strong>
                      </td>
                      <td className={styles.categoryCell}>{item.category}</td>
                      {/* <td className={styles.descriptionCell}>
                        {item.questionText}
                      </td> */}
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
      )}

      {!isNaN(impactData.averagePercentage) && (
        <div className={styles.changeSection}>
          <span className={styles.percentage}>
            {impactData.averagePercentage > 0 ? "+" : ""}
            {impactData.averagePercentage}%
          </span>
          <span className={styles.label}>Change from Baseline Functioning</span>
        </div>
      )}
    </div>
  );
};

export default NewCardBox;
